import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './Request.css';
import requestImg from '../../assets/images/request-icon.png';
import calendarImg from '../../assets/images/calendar-icon.png';
import weightImg from '../../assets/images/weight-icon.png';
import arrowImg from '../../assets/images/arrow-right-icon.png';
import expandImg from '../../assets/images/arrow-down-icon.png';
import editImg from '../../assets/images/edit-black-icon.png';
import Icon from '../../components/UI/Icon/Icon';
import axios from '../../axios-trips';
import logError from '../../store/LogError';
import Button from '../../components/UI/Button/Button';
import * as actionTypes from '../../store/actions';
import Aux from '../../hoc/Auxiliary/Auxiliary';

class Request extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      initialIndex: this.props.index,
      currIndex: this.props.index,
      animate: 0,
      myNotifications: []
    };
  }

  changeExpandedHandler = () => {
    let expanded = this.state.expanded;
    expanded = !expanded;
    this.setState({expanded: expanded});

    if (expanded) {
      const notificationIds = [...this.state.myNotifications.map(obj => obj.id)];
      axios({
        method: 'post',
        url: '/api/v1/notifications/open-for-me',
        data: notificationIds,
        headers: {'Authorization': 'Bearer ' + this.props.access_token},
      })
      .then(response => {
        this.removeNotificationsFrontend(notificationIds);
      })
      .catch(error => {
        console.log(error);
      });
    }
  }

  updateNotifications() {
    const notificationIds = [...this.state.myNotifications.map(obj => obj.id)];
    axios({
      method: 'post',
      url: '/api/v1/notifications/open-for-all',
      data: notificationIds,
      headers: {'Authorization': 'Bearer ' + this.props.access_token},
    })
    .then(response => {
      this.removeNotificationsFrontend(notificationIds);
    })
    .catch(error => {
      console.log(error);
    });
  }

  removeNotificationsFrontend(notificationIds) {
    let updatedNotifications = {};
    Object.keys(this.props.externalNotifications).forEach((key, i) => {
      if (!notificationIds.includes(key)) {
        updatedNotifications[key] = {...this.props.externalNotifications[key]};
      }
    });
    if (this.state.myNotifications.length > 0) {
      this.props.onSetExternalNotifications(updatedNotifications);
    }
  }

  openRequestNotifications() {
    axios({
      method: 'post',
      url: '/api/v1/notifications/open-request',
      data: [parseInt(this.props.id.substring(1, this.props.id.length))],
      headers: {'Authorization': 'Bearer ' + this.props.access_token},
    })
    .then(response => {})
    .catch(error => {
      console.log(error);
    });
  }

  roundNum(num) {
    return Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100;
  }

  componentDidMount() {
    if (this.props.externalNotifications) {
      const newNotifications = [];
      const myId = parseInt(this.props.id.substring(1, this.props.id.length), 10);
      Object.keys(this.props.externalNotifications).forEach(key => {
        if (this.props.externalNotifications[key].tripId === myId &&
            this.props.externalNotifications[key].notificationType === "Request") {
          newNotifications.push(this.props.externalNotifications[key]);
        }
      });
      this.setState({ myNotifications: newNotifications });
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextProps.externalNotifications !== this.props.externalNotifications) {
      const newNotifications = [];
      const myId = parseInt(nextProps.id.substring(1, nextProps.id.length));
      Object.keys(nextProps.externalNotifications).forEach(key => {
        if (nextProps.externalNotifications[key].tripId === myId &&
            nextProps.externalNotifications[key].notificationType === "Request") {
          newNotifications.push(nextProps.externalNotifications[key]);
        }
      });
      this.setState({ myNotifications: newNotifications });
    }

    if (this.props.manager !== nextProps.manager ||
        this.props.origin !== nextProps.origin ||
        this.props.destination !== nextProps.destination ||
        this.props.requestTripDate !== nextProps.requestTripDate ||
        this.props.priority !== nextProps.priority ||
        this.props.weight !== nextProps.weight ||
        this.props.id !== nextProps.id ||
        this.props.partialLoad !== nextProps.partialLoad ||
        this.props.dateFlexbility !== nextProps.dateFlexbility ||
        this.props.unloading !== nextProps.unloading ||
        this.props.initiator !== nextProps.initiator ||
        this.props.tripId !== nextProps.tripId ||
        this.props.unloadAfter !== nextProps.unloadAfter ||
        this.props.moneyRequests !== nextProps.moneyRequests) {
      this.setState({ animate: this.state.animate + 1 });
    }
  }

  reset = () => {
    const request = {
      id: this.props.id.substring(1, this.props.id.length),
      manager: this.props.manager,
      requestTripDate: this.props.requestTripDate,
      origin: {
        ...this.props.locations[this.props.origin]
      },
      destination: {
        ...this.props.locations[this.props.destination]
      },
      priority: this.props.priority,
      requestType: this.props.requestType,
      weight: parseFloat(this.props.weight),
      partialLoad: this.props.partialLoad,
      dateFlexibility: this.props.dateFlexibility,
      unloading: this.props.unloading,
      initiator: this.props.initiator,
      tripId: null,
      unloadAfter: this.props.unloadAfter,
      moneyRequests: this.props.moneyRequests,
      sorting: this.props.sorting
    }

    this.setState({ loading: true });
    axios({
      method: 'post',
      url: '/api/v1/requests/update',
      data: request,
      headers: {'Authorization': 'Bearer ' + this.props.access_token},
    })
    .then(response => {
      console.log(response);
      this.setState({ loading: false });
      this.props.addNotification("Заявка успешно сохранена.", "Success");
      this.onRequestUpdateHandler();
    })
    .catch(error => {
      console.log(error);
      this.setState({ loading: false });
      if (error.response) {
        logError(
          this.props.access_token,
          this.props.codeToMessage[error.response.status],
          '/api/v1/requests/update'
        );
        this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
      }
    });
  }

  onRequestUpdateHandler = () => {
    const updatedRequests = [...this.props.requests];
    for (let i = 0; i < updatedRequests.length; i++) {
      if (parseInt(this.props.id.substring(1, this.props.id.length)) === parseInt(updatedRequests[i].id)) {
        updatedRequests[i].tripId = null;
        break;
      }
    }
    this.props.onSetRequests(updatedRequests);
  }

  constructCard = () => {
    let card = {
      id: this.props.id,
      index: this.props.index,
      manager: this.props.manager,
      weight: this.props.weight,
      origin: this.props.origin,
      destination: this.props.destination,
      requestTripDate: this.props.requestTripDate,
      dateFlexibility: this.props.dateFlexibility,
      priority: this.props.priority,
      requestType: this.props.requestType,
      partialLoad: this.props.partialLoad,
      tripId: this.props.tripId,
      initiator: this.props.initiator,
      unloading: this.props.unloading,
      unloadAfter: this.props.unloadAfter,
      moneyRequests: this.props.moneyRequests
    };

    console.log("Created card with id: " + card.id);

    return card;
  }

  formatDate(date) {
    return date.substring(8, 10) + "/" + date.substring(5, 7) + "/" + date.substring(0, 4);
  }

  openRequest = (ev) => {
    ev.preventDefault();
    this.props.setRequestHandler(this.constructCard());
    if (this.props.role === "ROLE_DISPATCHER") {
      this.updateNotifications();
      this.openRequestNotifications();
    }
  }

  getId(id) {
    id = parseInt(id.substring(1, id.length));
    if (id < 10) {
      return "00" + id;
    } if (id < 100) {
      return "0" + id;
    }

    if (id.length == 3) {
      return id;
    } else {
      return id.toString().substring(id.toString().length - 3, id.toString().length);
    }
  }

  startDragHandler = (e) => {
    e.dataTransfer.setData("text/html", e.parentNode);
    setTimeout(() => {
      this.props.onStartDrag(this.props.id, this.props.origin, this.props.destination);
    }, 0);
  }

  finishDragHandler = (event) => {
    this.props.stopDrag();
  }

  render() {
    let bottomClass = [classes.Bottom];
    let expandArrowClass = classes.ExpandIcon;

    if (this.state.expanded) {
      bottomClass.push(classes.Expanded);
    }

    let priority = classes.p3;
    if (this.props.priority === "П3") {
      priority = classes.p3;
    } else if (this.props.priority === "П2") {
      priority = classes.p2;
    } else if (this.props.priority === "П1") {
      priority = classes.p1;
    }

    let headerClasses = [classes.Header];
    headerClasses.push(classes.HeaderWhite);
    if (this.props.highlighted) {
      headerClasses.push(classes.HeaderHighlighted);
    }
    if (this.props.warning) {
      headerClasses.push(classes.HeaderWarning);
    }

    let requestClasses = [classes.Request];
    if (this.props.tripId != undefined) {
      requestClasses.push(classes.RequestWithTrip);
    }

    let capacityFilled = this.props.moneyRequests ? this.props.moneyRequests.reduce((a, b) => a + (b.weight || 0), 0) : 0;
    let filled = capacityFilled / this.props.weight * 100
    let filledExcess = capacityFilled - this.props.weight;
    let filledActual = filled > 100 ? 100 - filledExcess / capacityFilled * 100 : filled;
    let proportionFilled = (Math.min(Math.max(filledActual, 3), 96)) + "%";
    let proportionAvailable = Math.max(Math.min(96, (capacityFilled > this.props.weight ? 100 - filledActual : 100 - filledActual)), 3) + "%";
    let capacityFilledClass = [classes.RequestCapacityAvailable];
    if (filled > 100) {
      capacityFilledClass.push(classes.OverfilledCapacity);
    }
    let filledVisible = filled > 0 && this.props.weight > 0 ? "inline-block" : "none";
    let filledAvailable = capacityFilled !== this.props.weight ? "inline-block" : "none";
    proportionFilled = capacityFilled !== this.props.weight ? proportionFilled : "100%";
    proportionAvailable = filled > 0 && this.props.weight > 0 ? proportionAvailable : "100%";

    let content = (
      <div key={this.state.animate} className={headerClasses.join(' ')}>
        <div className={classes.HeaderMain}>
          {
            this.props.role === "ROLE_ADMIN" || this.props.role === "ROLE_DISPATCHER" || this.props.role === "ROLE_MANAGER" || this.props.role === "ROLE_RULER" ?
            <div className={classes.HeaderAction1} onClick={this.openRequest}>
              <Icon iconClass={expandArrowClass} iconSource={editImg} iconAlt='' />
            </div>
            : null
          }

          <div className={classes.RequestTitle} onClick={this.changeExpandedHandler}>
              <Icon iconClass={classes.RequestIcon} iconSource={requestImg} iconAlt='' />
              <p>{this.getId(this.props.id)}.&nbsp;</p>
              <p>{this.props.origin}</p>
              <Icon iconClass={classes.ArrowIcon} iconSource={arrowImg} iconAlt='' />
              <p style={{paddingRight: "5px"}}>{this.props.destination}</p>

              { this.state.myNotifications.length > 0 ?
                <div className={classes.NotificationCount} onClick={this.openTrip}>
                  <p className={classes.NotificationText}>{this.state.myNotifications.length}</p>
                </div>
                : null }
          </div>

          <div className={classes.RequestDate} onClick={this.changeExpandedHandler}>
            <Icon iconClass={classes.CalendarIcon} iconSource={calendarImg} iconAlt='' className={classes.CalendarIcon} />
            <p>{this.formatDate(this.props.requestTripDate)} +{this.props.dateFlexibility}</p>

            <div className={classes.RequestWeight} onClick={this.changeExpandedHandler}>
              <Icon iconClass={classes.CalendarIcon} iconSource={weightImg} iconAlt='' />
              <p className={classes.Weight}>{this.props.weight}</p>
            </div>
          </div>

          <div className={classes.RequestCapacity} onClick={this.changeExpandedHandler}>
            <div className={classes.RequestCapacitySlider}>
              <div className={classes.RequestCapacityFilled} style={{width: proportionFilled, display: filledVisible}}>
                <p className={classes.CapacityFilledText}></p>
              </div>
              <div className={capacityFilledClass.join(' ')} style={{width: proportionAvailable, display: filledAvailable}}>
                <p className={classes.CapacityAvailableText}></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    if (this.props.warning) {
      content = (
        <button className={headerClasses.join(' ')} onClick={this.reset}>
          <div className={classes.RequestTitle}>
            <Icon iconClass={classes.RequestIcon} iconSource={requestImg} iconAlt='' />
            <p>{this.getId(this.props.id)}.&nbsp;</p>
            <p>{this.props.origin}</p>
            <Icon iconClass={classes.ArrowIcon} iconSource={arrowImg} iconAlt='' />
            <p style={{paddingRight: "5px"}}>{this.props.destination}</p>

            <Icon iconClass={expandArrowClass} iconSource={expandImg} iconAlt='' />
          </div>

          <div className={classes.RequestWeight}>
            <Icon iconClass={classes.CalendarIcon} iconSource={weightImg} iconAlt='' />
            <p className={classes.Weight}>{this.props.weight}</p>
            <div className={classes.ManagerShortName}>{this.props.manager}</div>
            <div className={classes.RequestPriority + " " + priority}>
              {this.props.priority}
            </div>
          </div>

          <div className={classes.RequestDate}>
            <Icon iconClass={classes.CalendarIcon} iconSource={calendarImg} iconAlt='' className={classes.CalendarIcon} />
            <p>{this.formatDate(this.props.requestTripDate)} +{this.props.dateFlexibility}</p>
          </div>
        </button>
      );
    }

    return (
      <div
        className={requestClasses.join(' ')}
        onDragStart={this.startDragHandler}
        onDragEnd={this.finishDragHandler}
        draggable={true} >

        { content }

        <div className={bottomClass.join(' ')}>
          <div className={classes.Body} >
            <div className={classes.ManagerShortName}>{this.props.manager}</div>

            <div>Из <strong>{this.props.origin}</strong> в <strong>{this.props.destination}</strong></div>
            <div>Дата: {this.formatDate(this.props.requestTripDate)} +{this.props.dateFlexibility}</div>
            <div>Тип: {this.props.requestType}</div>
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = state => {
  return {
    access_token: state.access_token,
    routes: state.routes,
    dragInitialData: state.dragInitialData,
    dragOverObj: state.dragOverObj,
    role: state.role,
    requests: state.requests,
    locations: state.locations,
    externalNotifications: state.externalNotifications,
    codeToMessage: state.codeToMessage
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onStartDrag: (id, origin, destination) => dispatch({ type: actionTypes.START_DRAG,
                                                         id: id,
                                                         origin: origin,
                                                         destination: destination }),
    addNotification: (notification, notificationType) => dispatch({ type: actionTypes.ADD_NOTIFICATION,
                                                                    notification: notification,
                                                                    notificationType: notificationType }),
    onSetRequests: (requests) => dispatch({ type: actionTypes.REQUESTS,
                                            requests: requests }),
    onSetExternalNotifications: (externalNotifications) => dispatch({ type: actionTypes.SET_EXTERNAL_NOTIFICATIONS,
                                                                      externalNotifications: externalNotifications})
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Request);



// WEBPACK FOOTER //
// ./src/containers/Request/Request.js